import { HomeProcessingRule } from '../interfaces';

export const homeEmptyProductsRule: HomeProcessingRule = context => ({
	...context,
	showEmptyProducts:
		!context.isProductsLoading && (context.products?.length ?? 0) === 0,
});
